import { create } from 'zustand'
import { persist } from 'zustand/middleware'

/**
 * Empresa-cliente seleccionada por un usuario CONFORMITY, compartida entre
 * Productos, Proyectos y Lotes.
 *
 * Antes de esto, cada módulo tenía su propio `useState` local — un usuario
 * CONFORMITY que revisaba varios módulos de la misma empresa tenía que
 * volver a elegirla en cada página, lo que hacía sentir el sistema
 * incompleto (auditoría de cierre de frontend, 16 agosto 2026).
 *
 * Persistido en sessionStorage: sobrevive la navegación entre módulos y un
 * F5, pero se limpia solo al cerrar la pestaña — no es una preferencia
 * permanente de cuenta, solo continuidad dentro de la sesión de trabajo.
 * Un CLIENTE nunca usa este store (su tenant viene fijo del JWT vía
 * useCurrentTenant).
 */
interface TenantSelectionState {
  selectedTenantId: string | null
  setSelectedTenantId: (tenantId: string | null) => void
}

export const useTenantSelectionStore = create<TenantSelectionState>()(
  persist(
    (set) => ({
      selectedTenantId: null,
      setSelectedTenantId: (tenantId) => set({ selectedTenantId: tenantId }),
    }),
    {
      name: 'tenant-selection-storage',
      storage: {
        getItem: (name) => {
          const value = sessionStorage.getItem(name)
          return value ? JSON.parse(value) : null
        },
        setItem: (name, value) => sessionStorage.setItem(name, JSON.stringify(value)),
        removeItem: (name) => sessionStorage.removeItem(name),
      },
    },
  ),
)
